<template>
  <div class="main-footer-container">
    <floating-buttons />
    <div class="footer-cta">
      <a
        href="https://alvaroapoio.com.br/fale-conosco/contato"
        class="footer-cta__link"
      > Solicite um orçamento </a>
    </div>
  </div>
</template>

<script>
import FloatingButtons from '../components/FloatingButtons.vue'
export default {
  name: 'SiteFooter',
  components: { FloatingButtons },
  methods: {
    reachedBottom(isVisible) {
      let btns = document.getElementById('floatBtn')
      if (isVisible) {
        btns.classList.toggle('floating-buttons--absolute')
      } else {
        btns.classList.remove('floating-buttons--absolute')
      }
    }
  }
}
</script>

<style lang="scss">
.main-footer-container {
  position: relative;
  z-index: 1;
}
.footer-cta {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 0;

  &__link {
    display: block;
    text-transform: uppercase;
    color: white !important;
    padding-top: 15px !important;
    width: 260px;
    height: 50px;
    background-color: #642646;
    color: #fff !important;
    text-transform: uppercase;
    text-align: center;
    border-radius: 4px;
    text-decoration: none !important;
  }
}
</style>
